import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import _classCallCheck from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * body-row.tsx
 *
 * Forked from reactabular-table version 8.14.0
 * https://github.com/reactabular/reactabular/tree/v8.14.0/packages/reactabular-table/src
 */
import { isEqual, isFunction } from 'lodash';
import * as React from 'react';
import { columnsAreEqual } from './columns-are-equal';
import { evaluateFormatters } from './evaluate-formatters';
import { evaluateTransforms } from './evaluate-transforms';
import { mergeProps } from './merge-props';
export var BodyRow = /*#__PURE__*/function (_React$Component) {
  _inherits(BodyRow, _React$Component);

  var _super = _createSuper(BodyRow);

  function BodyRow() {
    _classCallCheck(this, BodyRow);

    return _super.apply(this, arguments);
  }

  _createClass(BodyRow, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
          columns = _this$props.columns,
          rowData = _this$props.rowData; // Check for row based override.

      var renderers = nextProps.renderers;

      if (renderers && renderers.row && renderers.row.shouldComponentUpdate) {
        if (isFunction(renderers.row.shouldComponentUpdate)) {
          return renderers.row.shouldComponentUpdate.call(this, nextProps, {}, {});
        }

        return true;
      }

      return !(columnsAreEqual(columns, nextProps.columns) && isEqual(rowData, nextProps.rowData));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          columns = _this$props2.columns,
          renderers = _this$props2.renderers,
          onRow = _this$props2.onRow,
          rowKey = _this$props2.rowKey,
          rowIndex = _this$props2.rowIndex,
          rowData = _this$props2.rowData;
      return React.createElement(renderers.row, onRow(rowData, {
        rowIndex: rowIndex,
        rowKey: rowKey
      }), columns.map(function (column, columnIndex) {
        var property = column.property,
            cell = column.cell,
            props = column.props;
        var evaluatedProperty = property || cell && cell.property;

        var _ref = cell || {},
            _ref$transforms = _ref.transforms,
            transforms = _ref$transforms === void 0 ? [] : _ref$transforms,
            _ref$formatters = _ref.formatters,
            formatters = _ref$formatters === void 0 ? [] : _ref$formatters;

        var extraParameters = {
          columnIndex: columnIndex,
          property: evaluatedProperty,
          column: column,
          rowData: rowData,
          rowIndex: rowIndex,
          rowKey: rowKey
        };
        var transformed = evaluateTransforms(transforms, rowData[evaluatedProperty], extraParameters);

        if (!transformed) {
          // eslint-disable-next-line no-console
          console.warn('Table.Body - Failed to receive a transformed result');
        }

        return React.createElement(renderers.cell, Object.assign({
          key: "col-".concat(columnIndex, "-row-").concat(rowIndex)
        }, mergeProps(props, cell && cell.props, transformed)), transformed.children || evaluateFormatters(formatters)(rowData["_".concat(evaluatedProperty)] || rowData[evaluatedProperty], extraParameters));
      }));
    }
  }]);

  return BodyRow;
}(React.Component);
BodyRow.displayName = 'BodyRow';
BodyRow.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onRow: function onRow() {
    return Object;
  }
};